__turbopack_context__.v({
  "border": "styles-module-scss-module__0TjDoG__border",
  "clickable": "styles-module-scss-module__0TjDoG__clickable",
  "content": "styles-module-scss-module__0TjDoG__content",
  "leadingAddon": "styles-module-scss-module__0TjDoG__leadingAddon",
  "listItem": "styles-module-scss-module__0TjDoG__listItem",
  "trailingAddon": "styles-module-scss-module__0TjDoG__trailingAddon",
});
